import { render, staticRenderFns } from "./StudentLearningAccountListPage.vue?vue&type=template&id=5734c5c8&scoped=true"
import script from "./StudentLearningAccountListPage.vue?vue&type=script&lang=js"
export * from "./StudentLearningAccountListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5734c5c8",
  null
  
)

export default component.exports